import { token } from '@atlaskit/tokens';

export const REMIX_PLACEHOLDER_WIDGET_KEY = 'ai-suggestions-remix-placeholder';

/** Marks the widget host; the placeholder inside is portalled, so only the host is always present. */
export const REMIX_PLACEHOLDER_CONTAINER_TESTID = 'ai-suggestions-remix-placeholder-container';

/** Block-level, non-editable host that the RemixPlaceholder portal renders into. */
export function createRemixPlaceholderContainer(): HTMLElement {
	const element = document.createElement('div');
	element.contentEditable = 'false';
	element.setAttribute('data-testid', REMIX_PLACEHOLDER_CONTAINER_TESTID);
	// Reserve the animation's dimensions before its React portal mounts so the initial scroll
	// centres the full placeholder.
	element.setAttribute(
		'style',
		`display: block;
		width: 100%;
		max-width: 760px;
		aspect-ratio: 16 / 9;
		margin: ${token('space.150')} auto;
		pointer-events: none;`,
	);
	return element;
}
